export default __webpack_public_path__ + "static/media/logo-leclerc-small.3c2c7955.svg";